// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Tj-vu","inner":"Button_inner__hX42a"};